import axios from 'axios'

const api = axios.create({
  baseURL: (window.__env__ && window.__env__.VUE_APP_API_URL) || process.env.VUE_APP_API_URL,
  timeout: 10000, // tempo máximo de resposta (opcional)
  validateStatus: function () {
    return true
  }
})




export default api